<template>
  <div class="FourLinkagePanel">
  	<div id="hiddenBg" class="e-dlg-overlay" style="z-index: 1000; display: none; position: flex;"></div>
  
    <div class="h-topo_pw2" v-show="see" style="width:330px;height:550px; background:#000000; opacity: 1;z-index:1001;border-radius:4px;" :style="PositionXY">

      <div style="width:100%; ">
          	
            <label class="topo_title_w200" style="margin: 12px 0 0 10px;width:260px;" :title='name'>{{$t('Topo.podName')}}：{{name}}</label>
            
        	<a style="cursor:pointer; text-decoration:none; float:right; margin: 8px 0 0 0;">
	          <span @click="click()" class="e-btn-icon icon hero-icon hero-icon-remove-small"  style="color:#ddd;" :title="$t('Common.close')"></span>
	        </a>             
      </div>
      
      <div style="width:100%;height:520px;"> 	      	 
	      	 
	      	 <!-- Begin Form Type One -->
      		 <div class="h-topo_content" style="height:auto;width: 100%;">	      		 
      		 	
      		 	<div class="form-group" style="margin: 0 0 0 12px;">      		 	
      		 		{{$t('Topo.nameSpace')}} : {{namespace}}
      		 	</div> 
      		 	<div class="form-group" style="margin: 8px 0 0 12px;">      		 	
      		 		{{$t('Topo.id')}} : {{id}}
      		 	</div> 
      		 	<div class="form-group" style="margin: 8px 0 0 12px;">      		 	
      		 		{{$t('Topo.runningStatus')}} : {{status}}
      		 	</div>  
      		 	<div class="form-group" style="margin: 8px 0 0 12px;">      		 	
      		 		{{$t('Topo.ip')}} : {{ip}}
      		 	</div>     		 			 
		     </div>  
	      	 <hr style=" margin: 15px 5px 10px 12px;border-color: #dddddd;"/> 
	      	 
	      	 <!-- Begin Form Type Two -->
		     <div style="min-height:180px;margin-top: 0;">		       		
		       		<ejs-grid ref='gridContainer' id='gridContainer' gridLines='None' :dataSource="dsContainer" :enableHover='false'	       			
			                rowHeight="20" :allowSelection="true" :selectionSettings='selectOptions' :rowSelected="rowSelectedContainer">
			                <e-columns>	
			                	<e-column field='id' :visible='false' :isPrimaryKey='true'></e-column>	                   
			                    <e-column field='name' :headerText="$t('Topo.containerName')" width='100' :template='nameTemplate'></e-column>	
			                    <e-column field='cpuUsage' :headerText="$t('Topo.cpuUsage')" width='100' ></e-column>
			                    <e-column field='memoryUsage' :headerText="$t('Topo.memoryUse')" width='100'></e-column>		                   
			                </e-columns>
	                </ejs-grid>
		     </div> 
		     <hr style=" margin: 15px 5px 10px 12px;border-color: #dddddd;"/>  
		     <!-- /.END Form Type Two -->
		       
		       
		    <!-- Begin Form Type Three -->		
		    <div>     
				<ejs-grid ref='gridProcess' id='gridProcess' gridLines='None' :dataSource="dsProcess" ::enableHover='false' 
					        rowHeight="20" :allowSelection='true' :selectionSettings='selectOptions' >
					        <e-columns>		                   
					      
					            <e-column field='pid' :headerText="$t('Topo.servicePID')" width='100' ></e-column>
					            <e-column field='cpuUsage' :headerText="$t('Topo.cpuUsage')" width='100'></e-column>		
					            <e-column field='memoryUsage' :headerText="$t('Topo.memoryUse')" width='100'></e-column>	                    
					        </e-columns>
					</ejs-grid>		
			</div>	      
		    <!-- /.END Form Type Three -->            

      </div>
    </div>  
     
  </div>
</template>

<script>
	
	import nameLinkTemplate from "../../components/topoconfig/template/nameLinkTemplate.vue";
	import { EventBus } from '../../plugins/eventBus';
	import {createNamespacedHelpers} from "vuex";
	const { mapGetters, mapActions } = createNamespacedHelpers('topoConfig');
  
	export default {
	    name: "ThreeListLinkageContainer",
	    components: {
	     
	    },
		computed: {
	      
	    },
	    data() {
		    return {	       
				dsContainer: [],
				dsProcess: [],				
			    selectOptions: { type: 'Single', mode: 'Row' },		   
		        PositionXY: "",	
		        id:'',	         
		        name: '',
		        namespace: '',
		        status: '',
		        ip: '',
		        see: false,	       
		        gridLines: 'None',
		        nameTemplate: function () {
			         return { template : nameLinkTemplate}
			    },
		    };
	    },
	    props: ["threeListLinkageContainer"],
	    methods: {
	    
		      rowSelectedContainer: function( args ){
	    			if(args !=null && args.data.children !=null)
		        		this.dsProcess = args.data.children;	        		
		        	else
		        		this.dsProcess = [];	        	
		      },	     
			  getLang( key){
			  
			  		return this.$t(key);
			  },    
		      click() {
		           
		           	//-- must see then can clear;
				    this.$refs.gridContainer.clearSelection();
					this.$refs.gridProcess.clearSelection(); 		
		           
		      		this.$options.parent.threeListLinkageContainer.seeObj = false;
		      		this.$options.parent.$refs.gridPhysicPOD.clearSelection();
		      		
		      		document.getElementById('hiddenBg').style.display = "none";	
			        this.see = !this.see;
		      }	
		     
	    },	
	    mounted() {},
	    watch: {
	      //父子动态传值
	      threeListLinkageContainer: {
	        handler: function(newVal, oldVal) {        
	        	  
	        	  if(newVal.seeObj)
	        	  {
	        	  		this.see = newVal.seeObj;
						this.PositionXY = newVal.PositionXY;
				      	this.id = newVal.id;
				      	this.ip = newVal.ip;
				      	this.name = newVal.name;
				      	this.namespace = newVal.namespace;
				      	this.status = newVal.status;
				      	this.dsProcess = [];
				      	this.dsContainer = [];
				      	this.dsContainer = newVal.dsContainer;
			          	
			          	document.getElementById('hiddenBg').style.display = "flex";
	        	  	
	        	  }
		        	
	        },
	        deep: true
	      }
	    }
  };
</script>

<style>

#gridContainer, #gridProcess{

	background: #000000;
    border: 0 none;
}

#gridContainer.e-grid .e-content {
    max-height: 156px;
    overflow-y: scroll;
}

#gridProcess.e-grid .e-content {
    max-height: 160px;
    overflow-y: scroll;
}

.topo-title a:hover
{
	text-decoration: none;
}
</style>

